import { useContext } from "react";
import stableStringify from "json-stable-stringify";
import { IconButton } from "../IconButton";
import LegoAdminPageContext from "../../../pages/legoAdminPageContext";
import TextDiff from "../../test-sets/TextDiff";

export default function BtnSeeDiff({ a, b, ellipsis = 100, title = 'See diff of changes', className = '', children = null }) {
    const { page } = useContext(LegoAdminPageContext);

    const openModalDiffChanges = () => {
        page.openModal(<div>
            <div className={'p-2 bg-light monospace small break-word-all'}>
                <TextDiff type={'json'} inputB={stableStringify(b, { space: 2 })}
                    ellipsis={ellipsis}
                    inputA={stableStringify(a, { space: 2 })} />
            </div>
        </div>, { title });
    }

    return <IconButton icon={'compare'} level={'primary'} description={'See diff of changes'}
        onClick={openModalDiffChanges} className={className}>{children || 'See diff'}</IconButton>
}